import LocalizedLink from '@components/Localization/LocalizedLink'
import { Link } from '@components/gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type IsolatedRolexLinkProps = {
  variant: 'regular' | 'pre-owned'
}

export const IsolatedRolexLink: FC<IsolatedRolexLinkProps> = ({ variant }) => {
  const { t } = useTranslation('navigation')
  return (
    <>
      {variant === 'pre-owned' ? (
        <LocalizedLink href={t('rcpo.selection.url')}>
          <Link className="mb-6 inline-block" variant="brown">
            Rolex Certified Pre-Owned
          </Link>
        </LocalizedLink>
      ) : (
        <LocalizedLink href="/rolex">
          <Link className="mb-6 inline-block" variant="brown">
            Rolex
          </Link>
        </LocalizedLink>
      )}
    </>
  )
}
